// Dashboard
const Dashboard = () =>
    import(/* webpackChunkName: "dashboard" */ "src/modules/Dashboard");
const DashboardLayout = () =>
    import(/* webpackChunkName: "dashboard" */ "src/modules/DashboardLayout");
const Account = () =>
    import(/* webpackChunkName: "dashboard" */ "src/modules/Account");
const Settings = () =>
    import(/* webpackChunkName: "dashboard" */ "src/modules/Settings");

// User
const Users = () =>
    import(/* webpackChunkName: "users" */ "src/modules/User/Users");
const UserDetail = () =>
    import(/* webpackChunkName: "users" */ "src/modules/User/UserDetail");

// Customer
const Customers = () =>
    import(
        /* webpackChunkName: "customers" */ "src/modules/Customer/Customers"
    );
const CustomerReceiptLogs = () =>
    import(
        /* webpackChunkName: "customers" */ "src/modules/Customer/CustomerReceiptLogs"
    );

// ReceiptLog
const ReceiptLogs = () =>
    import(
        /* webpackChunkName: "receipts" */ "src/modules/ReceiptLog/ReceiptLogs"
    );
const ReceiptLogDetail = () =>
    import(
        /* webpackChunkName: "receipts" */ "src/modules/ReceiptLog/ReceiptLogDetail"
    );
const ReceiptLogUnitDetail = () =>
    import(
        /* webpackChunkName: "receipts" */ "src/modules/ReceiptLog/ReceiptLogUnitDetail"
    );
// Alternate view for ReceiptLogs
const ReceiptLogUnits = () =>
    import(
        /* webpackChunkName: "receipts" */ "src/modules/ReceiptLog/ReceiptLogUnits"
    );

// PreOrders
const PreOrders = () =>
    import(
        /* webpackChunkName: "preorders" */ "src/modules/PreOrder/PreOrders"
    );
const PreOrderDetail = () =>
    import(
        /* webpackChunkName: "preorders" */ "src/modules/PreOrder/PreOrderDetail"
    );
const PreOrderUnitDetail = () =>
    import(
        /* webpackChunkName: "preorders" */ "src/modules/PreOrder/PreOrderUnitDetail"
    );
const NewPreOrderUnit = () =>
    import(
        /* webpackChunkName: "preorders" */ "src/modules/PreOrder/NewPreOrderUnit"
    );

// Quotes
const Quotes = () =>
    import(/* webpackChunkName: "quotes" */ "src/modules/Quote/Quotes");

// Invoice
const Invoices = () =>
    import(/* webpackChunkName: "invoices" */ "src/modules/Invoice/Invoices");

// Auth
const AuthLayout = () =>
    import(/* webpackChunkName: "auth" */ "src/components/AuthLayout.vue");
const Login = () => import(/* webpackChunkName: "auth" */ "src/modules/Login");
const Unauthorized = () =>
    import(
        /* webpackChunkName: "auth" */ "src/components/UnauthorizedPage.vue"
    );
const NotFound = () =>
    import(/* webpackChunkName: "auth" */ "src/components/NotFoundPage.vue");

const authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    children: [
        {
            path: "login",
            name: "Login",
            component: Login,
            props: true,
        },
    ],
};

const routes = [
    {
        path: "/",
        component: DashboardLayout,
        redirect: "/dashboard",
        name: "Home",
        meta: {
            requiresAuthentication: true,
        },
        children: [
            {
                path: "/dashboard",
                name: "Dashboard",
                component: Dashboard,
                meta: {
                    sidebar: {
                        name: "Dashboard",
                        icon: "fa fa-chart-pie",
                    },
                },
            },
            {
                path: "/customers",
                name: "Customers",
                component: Customers,
                meta: {
                    requiredRoles: [
                        "CompanyBasic",
                        "CompanyAdmin",
                        "Developer",
                    ],
                    sidebar: {
                        name: "Customers",
                        icon: "fa fa-users",
                    },
                },
            },
            {
                path: "/customer/:id",
                name: "Customer Receipt Logs",
                component: CustomerReceiptLogs,
                meta: {
                    requiredRoles: [
                        "CompanyBasic",
                        "CompanyAdmin",
                        "Developer",
                    ],
                },
            },
            {
                path: "/receipts",
                name: "Receipt Logs",
                component: ReceiptLogs,
                meta: {
                    sidebar: {
                        name: "Receipt Logs",
                        icon: "fa fa-receipt",
                    },
                },
            },
            {
                path: "/receipts/units",
                name: "Receipt Log Units",
                component: ReceiptLogUnits,
            },
            {
                path: "/receipt/:receiptId/:id",
                name: "Receipt Log Unit Detail",
                component: ReceiptLogUnitDetail,
            },
            {
                path: "/receipt/:id",
                name: "Receipt Log Detail",
                component: ReceiptLogDetail,
            },
            {
                path: "/preorders",
                name: "Pre-Orders",
                component: PreOrders,
                meta: {
                    requiredRoles: ["CompanyAdmin", "Developer"],
                    sidebar: {
                        name: "Pre-Orders",
                        icon: "fa fa-business-time",
                    },
                },
            },
            {
                path: "/preorder/:id",
                name: "Pre-Order Detail",
                component: PreOrderDetail,
                meta: {
                    requiredRoles: ["CompanyAdmin", "Developer"],
                },
            },
            {
                path: "/preorder/:id/new",
                name: "New Pre-Order Unit",
                component: NewPreOrderUnit,
                props: true,
                meta: {
                    requiredRoles: ["CompanyAdmin", "Developer"],
                },
            },
            {
                path: "/preorder/:preOrderId/:id",
                name: "Pre-Order Unit Detail",
                component: PreOrderUnitDetail,
                meta: {
                    requiredRoles: ["CompanyAdmin", "Developer"],
                },
            },
            {
                path: "/quotes",
                name: "Quotes",
                component: Quotes,
                meta: {
                    sidebar: {
                        name: "Quotes",
                        icon: "fa fa-quote-left",
                    },
                },
            },
            {
                path: "/users",
                name: "Users",
                component: Users,
                meta: {
                    requiredRoles: ["CompanyAdmin", "Developer"],
                    sidebar: {
                        name: "Users",
                        icon: "fa fa-male",
                    },
                },
            },
            {
                path: "/invoices",
                name: "Invoices",
                component: Invoices,
                meta: {
                    sidebar: {
                        name: "Invoices",
                        icon: "fa fa-file-invoice-dollar",
                    },
                },
            },
            {
                path: "/user/:id",
                name: "User Detail",
                component: UserDetail,
                meta: {
                    requiredRoles: ["CompanyAdmin", "Developer"],
                },
            },
            {
                path: "/account",
                name: "Account",
                component: Account,
                children: [
                    {
                        path: "general",
                        name: "General",
                        meta: {
                            activeTab: true,
                        },
                        component: Account,
                    },
                    {
                        path: "settings",
                        name: "Settings",
                        meta: {
                            activeTab: true,
                        },
                        component: Account,
                    },
                ],
            },
            {
                path: "/settings",
                name: "PortalSettings",
                component: Settings,
                meta: {
                    requiredRoles: ["CompanyAdmin", "Developer"],
                    sidebar: {
                        name: "Settings",
                        icon: "fa fa-cogs",
                    },
                },
                children: [
                    {
                        path: "invoices",
                        name: "SettingsInvoices",
                        meta: {
                            activeTab: true,
                        },
                        component: Settings,
                    },
                    {
                        path: "emails",
                        name: "Emails",
                        meta: {
                            activeTab: true,
                        },
                        component: Settings,
                    },
                ],
            },
            {
                path: "/unauthorized",
                name: "Unauthorized",
                component: Unauthorized,
            },
            {
                path: "*",
                name: "404",
                component: NotFound,
            },
        ],
    },
    authPages,
];

export default routes;
